import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getTeleauditKpiByQuestion = async ({ questionId, questionResponseId }) => {
  try {
    const { data } = await axios.get(`/api/teleaudit-kpi/question/${questionId}/${questionResponseId}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

export default getTeleauditKpiByQuestion;
